<template>
  <div>
    <loader v-if="loading" />
    <div
      v-else-if="!list.length"
      class="empty-list"
    >
      <v-icon
        color="light-gray"
        x-large
      >
        mdi-lightning-bolt-outline
      </v-icon>

      <div>No active charging sessions right now</div>
    </div>
    <div v-else>
      <div class="sec-label">
        Charging now · {{ filteredList.length }} session{{
          filteredList.length > 1 ? "s" : ""
        }}
      </div>
      <div class="list">
        <div
          v-for="bk in filteredList"
          :key="bk.id"
          :class="[
            'bk-card bk-card--active bk-card--live-card',
            {
              'bk-card--sel': selectedBooking && selectedBooking.id === bk.id,
            },
          ]"
          @click="$emit('open', bk)"
        >
          <!-- <div class="stripe" />  -->
          <!-- <div class="bk-id-row">
            <span class="bk-id-badge">Session No: {{ bk.id }}</span>
            <span class="live-tag">
              <span class="live-pulse live-pulse--sm" />
              LIVE
            </span>
          </div> -->
          <div class="bk-top">
            <div>
              <div class="bk-sub">
                {{ bk.started_at | formatDate("DD-MM-YYYY") }}
              </div>
              <div class="bk-time">
                {{ bk.started_at | formatDate("hh:mm A") }}
                <!-- <span class="ampm"> {{ bk.ampm }}</span> -->
              </div>
            </div>
            <span :class="['pill text-uppercase', pillClass(bk.status)]">
              <span class="dot" />
              {{ bk.status }}
            </span>
          </div>
          <div class="bk-body">
            <div class="avatar">
              {{ bk.customer_name[0] }}
            </div>
            <div class="bk-info">
              <div class="bk-name">
                {{ bk.customer_name }}
              </div>
              <div class="bk-veh">
                <span class="reg-tag"> {{ bk.make }} - {{ bk.model }} </span>
              </div>
              <div class="b-veh-model">
                {{ bk.location_name }}
              </div>
            </div>
            <!-- <div class="bk-port">
              <div class="port-num">Port-{{ bk.connector_no }}</div>
              <div class="port-type">
                {{ bk.connector_type }} - {{ bk.connector_power }}kW
              </div>
            </div> -->
            <v-icon class="chev">
              mdi-chevron-right
            </v-icon>
          </div>
          <div class="live-stats">
            <div class="live-stat">
              <div class="live-stat__val">
                {{ bk?.energy_consumed || 0 }}
                <span class="live-stat__unit">kWh</span>
              </div>
              <div class="live-stat__lbl">
                Delivered
              </div>
            </div>
            <!-- <div class="live-stat-div" />
            <div class="live-stat">
              <div class="live-stat__val">
                {{ bk?.charge_session?.duration_minutes || 0 }}
                <span class="live-stat__unit">min</span>
              </div>
              <div class="live-stat__lbl">Elapsed</div>
            </div> -->
            <!-- <div class="live-stat-div" />
            <div class="live-stat">
              <div class="live-stat__val">
                {{ bk?.charge_session?.total_cost || 0 }}
                <span class="live-stat__unit">
                  {{ bk?.charge_session?.currency }}
                </span>
              </div>
              <div class="live-stat__lbl">Amount</div>
            </div> -->
          </div>
          <!-- <div class="bk-duration">
            <v-icon small> mdi-clock-time-three-outline </v-icon>
            {{ bk.slot_duration_minutes }} min booking slot &nbsp;·&nbsp; Until
            {{ bk.end_time_format }}
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { pillClass } from "../utils/bookingHelpers";

export default {
  name: "LiveTab",
  components: {
    Loader: () => import("../utils/Loader.vue"),
  },
  props: {
    selectedBooking: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      interval: null,
    };
  },
  computed: {
    ...mapGetters({
      loading: "bookingOperator/getLoading",
      list: "bookingOperator/getWalkInSessions",
    }),
    filteredList() {
      return this.list.filter((r) => !r.vehicle_reg_no) || [];
    },
  },
  beforeDestroy() {
    if (this.interval) {
      clearTimeout(this.interval);
      this.interval = null;
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    pillClass,
    fetchData() {
      clearTimeout(this.interval);
      //
      const params = { filter_type: "walk_in" };
      this.$store.dispatch(`bookingOperator/walkInSessions`, params);
      //
      this.interval = setTimeout(this.fetchData, 15000);
    },
  },
};
</script>
<style scoped></style>
